import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Link } from "react-router-dom";

export default function NavItems({ hiddenNavItem, active, onClick, icon, title, url }) {
  const isDisabled = url === "#";
  
  const baseClasses = `grid grid-flow-col grid-cols-6 ${
    hiddenNavItem ? "px-4 py-3" : "px-2 py-1"
  } select-none transition-colors duration-300 w-full ${
    active
      ? "bg-linear-to-r from-white/50 to-transparent border-r-4 border-aw-green"
      : "bg-transparent border-r-transparent border-r-4"
  } ${!isDisabled ? "hover:bg-linear-to-r hover:from-white/50 hover:to-transparent hover:border-r-aw-green-30" : ""}`;

  const iconColor = active ? "text-aw-green" : isDisabled ? "text-white/40" : "text-neutral-100";
  const textColor = isDisabled ? "text-white/40" : "";

  return (
    <Link
      to={isDisabled ? undefined : url}
      disabled={isDisabled}
      className={baseClasses}
      onClick={onClick}
    >
      <div className={`flex items-center justify-center ${hiddenNavItem ? "col-span-1" : "col-span-full"}`}>
        <FontAwesomeIcon icon={`fa-solid fa-${icon}`} className={`text-lg ${iconColor}`} />
      </div>
      <span
        className={`text-sm font-medium col-span-5 transition-opacity ${textColor} ${
          hiddenNavItem ? "opacity-100 width-delay" : "opacity-0 w-0 width-delay-open"
        } ${isDisabled ? "relative" : ""}`}
      >
        {title}
        {isDisabled && (
          <span className="absolute top-0 right-0 italic bg-yellow-500 text-[10px] text-aw-bluedark rounded-2xl font-semibold py-0.5 px-1">
            Pronto
          </span>
        )}
      </span>
    </Link>
  );
}
